import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'selectedFilter',
    standalone: true,
})
export class SelectedFilter implements PipeTransform {
    transform(items: { key: string; value: string }[], filter: { key: string; value: string }): any {
        return items.filter((item) => item.key !== filter.key);
    }
}
